import localstorage from 'src/helper/localstorage'
import { getlang } from 'src/helper/getlang'
import dsbridge from 'dsbridge'
import brower from 'src/helper/brower'
import VConsole from 'src/helper/vconsole'
import { getUserInfo } from 'src/helper/webviewFun'
import config from 'src/core/config'

/**
 * 无路由的情况下获取url参数
 * @param name
 * @returns {*}
 */
export const getQueryString = function (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 匹配目标参数
  var result = window.location.search.substr(1).match(reg) // 对querystring匹配目标参数
  if (result != null) {
    return decodeURIComponent(result[2])
  } else {
    return null
  }
}

/**
 * 获取缩略图地址
 * @param pic 图片地址
 * @param w 宽
 * @param h 高
 * @param m 模式 0-6 http://wiki.yy.com/index.php/BS2_image%E7%BC%A9%E7%95%A5%E5%9B%BE%E6%8E%A5%E5%8F%A3
 * @param c 裁剪参数
 * @returns {string}
 */
export const thumb = function (pic, w = 0, h = 0, m = 0, c = -1) {
  let queryString = `?ips_thumbnail/${m}`
  if (c > -1) {
    queryString += `/${c}`
  }
  if (w > 0) {
    queryString += `/w/${w}`
  }
  if (h > 0) {
    queryString += `/h/${h}`
  }
  if (!w && !h) {
    queryString = ''
  }
  return `${pic}${queryString}`
}

export const setDocumentTitle = function (title) {
  document.title = title
  /*  const iframe = document.createElement('iframe')
    iframe.style.cssText = 'display: none; width: 0; height: 0;'
    iframe.src = 'https://mv.yy.com'

    const listener = () => {
      setTimeout(() => {
        iframe.removeEventListener('load', listener)
        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 0)
      }, 0)
    }
    iframe.addEventListener('load', listener)
    document.body.appendChild(iframe) */
}

export const randomWord = function (randomFlag, min, max) {
  let str = '',
    range = min,
    arr = [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
    ]

  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min // 任意长度
  }
  for (let i = 0; i < range; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}

export const setUidToken = async function (query) {
  let { uid, accesstoken } = query
  if (parseInt(uid) > 0 && accesstoken && accesstoken != '') {
  } else {
    let userInfo = await getUserInfo()
    if (
      userInfo &&
      userInfo.res &&
      userInfo.res.uid > 0 &&
      userInfo.res.accesstoken &&
      userInfo.res.accesstoken != ''
    ) {
      uid = userInfo.res.uid
      accesstoken = userInfo.res.accesstoken
    }
  }

  if (parseInt(uid) > 0 && accesstoken && accesstoken != '') {
    await localstorage.set('userInfo', { uid: parseInt(uid), accesstoken: accesstoken })
  }

  if (isNaN(parseInt(uid))) {
    return 0
  }
  return parseInt(uid)
}

export const waitTime = async function (sec) {
  return new Promise((resolve) => {
    setTimeout(function () {
      resolve()
    }, sec)
  })
}

export const setShare = async function (map) {
  // if (map.imageUrl && map.imageUrl != "") {
  dsBridge.call('setShare', JSON.stringify(map))
  // }
}

export const openShare = async function (map) {
  dsBridge.call('openShare', JSON.stringify(map))
}

export const shareWhatsapp = async function (map) {
  dsBridge.call('shareWhatsapp', JSON.stringify(map), function (d) {
    // console.log('调用结果' + JSON.stringify(d))
  })
}

export const shareLink = async function (map) {
  dsBridge.call('shareLink', JSON.stringify(map), function (d) {
    // console.log('shareLink调用结果' + JSON.stringify(d))
  })
}

// export const closeWebView = async function (map) {
//   dsBridge.call('closeWebView', JSON.stringify(map), function (d) {
//     console.log('调用结果' + JSON.stringify(d))
//   })
// }

export const setWebViewBackBtn = async function (map) {
  dsBridge.call('setWebViewBackBtn', JSON.stringify(map), function (d) {
    // console.log('调用结果' + JSON.stringify(d))
  })
}

export const InitPage = async function (query, lang, remember) {
  let uid = await setUidToken(query || { uid: 0, token: '' })

  let language = await getlang(query.lang)

  if (remember == true) {
    let la = await localstorage.get('language')
    if (la && la != undefined && la != '' && JSON.stringify(la) != `{}`) {
      language = la
    }
  }

  let langJson = lang.en
  switch (language) {
    case 'ar':
      langJson = lang.ar
      break
    case 'tr':
      langJson = lang.tr
      break
  }
  debugger
  return {
    language: language || 'en',
    uid: uid || 0,
    langJson: langJson,
  }
}

export const emailCheck = function (email) {
  var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/ // 正则表达式
  if (!reg.test(email)) {
    // 正则验证不通过，格式不对
    console.log('验证不通过!')
    return false
  } else {
    console.log('通过！')
    return true
  }
}

export const copy = function (message) {
  if (brower.isIphone()) {
    let input = document.createElement('input')
    input.value = message
    document.body.appendChild(input)
    input.select()
    ;(input.setSelectionRange(0, input.value.length), document.execCommand('Copy'))
    document.body.removeChild(input)
  } else {
    shareLink({
      url: message,
    })
  }
}

export const stringR = function (str) {
  if (
    str == undefined ||
    str == '' ||
    str == 'undefined' ||
    str == 'null' ||
    str == null ||
    str == NaN ||
    str == 0 ||
    Array.isArray(str)
  ) {
    return ''
  }
  return str + ''
}

export const showConsole = function () {
  if (
    window.location.href.indexOf('192.168') > -1 ||
    window.location.href.indexOf('-test.') > -1 ||
    window.location.href.indexOf('-test2.') > -1 ||
    window.location.href.indexOf('localhost') > -1 ||
    window.location.href.indexOf('dev=y') > -1
  ) {
  }
}

export const Trim = function (str) {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

// H5游戏加载完成
// dsBridge.call("webGameResLoadComplete", paramsJson)

export const numberThumbnail = (number) => {
  if (number >= 1000000) {
    number = parseInt(number / 100000) / 10 + 'M'
  } else if (number > 1000) {
    number = parseInt(number / 100) / 10 + 'K'
  }
  return number
}

export const getFileExtension = (url) => {
  try {
    // 从 URL 中提取文件名部分
    const filename = url.substring(url.lastIndexOf('/') + 1)
    // 确保 URL 包含文件名
    if (filename.indexOf('.') === -1) {
      throw new Error('No file extension found')
    }
    // 从文件名中提取后缀名
    const extension = filename.substring(filename.lastIndexOf('.') + 1)

    return extension
  } catch (error) {
    console.error('Invalid URL', error)
  }
}

// 获取媒体类型
export const getMediaType = (showType, showUrl) => {
  if (showType) return showType
  return getFileExtension(showUrl)
}

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function isRtl(language) {
  return ['ar', 'he', 'fa', 'ps', 'ur'].includes(language)
}

// 将毫秒换算成天数
export function convertMillisecondsToDays(ms) {
  let days = ms / (1000 * 60 * 60 * 24)
  return days < 1 ? Number(days.toFixed(1)) : Math.floor(days)
}

// 判断是否是 voca 项目
export function isVoca(env) {
  if (['vocaDev', 'vocaTesting', 'vocaUat', 'vocaProd'].includes(config.env)) {
    return true
  }
  return false
}

// 判断是否是俄罗斯域名
export function isRussiaHost() {
  const hostname = window.location.hostname
  return hostname.toLowerCase().endsWith('.hobychat.ru')
}

// 判断是否是生产环境
export function isProduction() {
  return ['vocaProd', 'production'].includes(config.env)
}



// WEBPACK FOOTER //
// src/helper/tool.js